import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Valentinovo",
  "description": "",
  "published": "2007-02-14T00:00:00.000Z",
  "redirect_from": ["/blog/valentinovo/swizec/286"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ce si ne ogledate `}<a parentName="p" {...{
        "href": "http://www.zefrank.com/valentine/"
      }}>{`tega cudovitega komentarja na valentinovo`}</a>{` vas bodo verjetno napadle zelene opice in vam pojedle oci.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      